import type { AppProps } from 'next/app';
import Head from 'next/head';
import { IntlProvider } from 'next-intl';
import { IndexContextProvider, IndexContextProps } from '@/stores/index';
import Layout from '@/components/layout';
import request from '@/utils/request';

import './global.scss';

const processMenu = (menu: any[], locale: string): any => {
  return menu.map((item: any) => ({
    ...item,
    _href: item?.out_link || (item?.childlist?.length > 0 ? item?.childlist[0]?.out_link || item?.childlist[0]?.path : item?.path),
    _target: item?.out_link ? item?.target : (item?.childlist?.length > 0 ? item?.childlist[0]?.target : item?.target),
    childlist: [...processMenu(item?.childlist, locale)]
  }));
};

const getMenuCurrent = (menu: any[], path: string): any => {
  for (let i = 0; i < menu?.length; i++) {
    const item = menu[i];
    if (item.path === path) {
      return item;
    }

    if (item.childlist && Array.isArray(item.childlist)) {
      const child = getMenuCurrent(item.childlist, path) as any;
      if (child) {
        return child;
      }
    }
  }

  return null;
}

const getMenuParent = (menu: any[], pid: string): any => {
  for (let i = 0; i < menu?.length; i++) {
    const item = menu[i];
    if (item.childlist && Array.isArray(item.childlist)) {
      if (item.id === pid) {
        return item;
      }
    }
  }

  return null;
}

function MyApp(data: AppProps & IndexContextProps & { locale: string; messages: any }): JSX.Element {
  const { Component, pageProps, router, locale, messages, menuList, webInfo } = data;
  const menuCurrent = getMenuCurrent(menuList, router.pathname);
  const menuParent = getMenuParent(menuList, menuCurrent?.pid);
  console.log("MyApp", menuList, menuCurrent, menuParent);
  return (
    <div>
      <Head>
        <title>IPB国际粉体、散料、流体加工展览会</title>
        <meta name="keywords" content="IPB国际粉体、散料、流体加工展览会" />
        <meta name="description" content="IPB国际粉体、散料、流体加工展览会" />
        <meta name="viewport" content="width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1,minimum-scale=1" />
        <meta name='thumbnail' content='/image/favicon.png' />
        <link rel="icon" type="image/png" href="/image/favicon.png" />
        {/* 百度统计 */}
        <meta name="baidu-site-verification" content="codeva-woSxZfgccH" />
        <script
          defer
          dangerouslySetInnerHTML={{
            __html: ` 
              var _hmt = _hmt || [];
              (function() {
                var hm = document.createElement("script");
                hm.src = "https://hm.baidu.com/hm.js?9b7475c8f53ba3c89d5c6afc1eb987b5";
                var s = document.getElementsByTagName("script")[0]; 
                s.parentNode.insertBefore(hm, s);
              })();
            `,
          }}
        />
      </Head>
      <IntlProvider locale={locale} messages={messages}>
        <IndexContextProvider value={{ menuList, menuCurrent, menuParent, webInfo }}>
          <Layout>
            <Component {...pageProps} />
          </Layout>
        </IndexContextProvider>
      </IntlProvider>
    </div>
  );
};

MyApp.getInitialProps = async (context: any) => {
  const locale = context?.ctx?.locale;

  const { data } = await request.get('/getHomeMenuList', {
    headers: {
      lang: locale || 'cn',
    }
  });

  const { data: info } = await request.get('/getWebInfo', {
    headers: {
      lang: locale || 'cn',
    }
  });

  const messages = await import(`../locales/${locale}/common.json`);
  // console.log("getInitialProps", messages);
  return {
    locale,
    messages,
    menuList: processMenu(data?.data || [], locale) || [],
    webInfo: info?.data || {}
  };
};

export default MyApp;
